var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoleBasedTeamAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 96 96",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 33,
    fill: "#fdcb9e",
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 38,
    fill: "#fdcb9e",
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.38 58.52a14.49 14.49 0 0 0 -1.53-1.69 16.8 16.8 0 0 0 -11.85-4.83 17 17 0 0 0 -17 17 2 2 0 0 0 2 2h21.8a2 2 0 0 0 1.91-1.41.64.64 0 0 0 0-.07 20.94 20.94 0 0 1 4.57-8.45l.07-.08a2 2 0 0 0 .03-2.47z",
    fill: "#95e1d3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 38,
    fill: "#fdcb9e",
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77 52a16.88 16.88 0 0 0 -11.86 4.83 16.34 16.34 0 0 0 -1.52 1.69 2 2 0 0 0 0 2.47l.08.09a20.94 20.94 0 0 1 4.56 8.44.64.64 0 0 0 0 .07 2 2 0 0 0 1.94 1.41h21.8a2 2 0 0 0 2-2 17 17 0 0 0 -17-17z",
    fill: "#95e1d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.13 68.48a25 25 0 0 0 -48.26 0 24.69 24.69 0 0 0 -.87 6.52 2 2 0 0 0 2 2h46a2 2 0 0 0 2-2 24.69 24.69 0 0 0 -.87-6.52z",
    fill: "#f38181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleBasedTeamAccess);
export default __webpack_public_path__ + "static/media/role-based-team-access.d070c822b7cda97c4a47ce4d2823896a.svg";
export { ForwardRef as ReactComponent };